import React, { useState } from "react";
import PropTypes from "prop-types";
import { composables } from "@orange-marmalade/paginate-this";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Route, withRouter } from "react-router";
import classNames from "classnames";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

function navLink(
  active,
  path,
  icon,
  title,
  reset,
  svg,
  hoverSvg,
  isHovered,
  setIsHovered
) {
  const classes = classNames({ active });
  const tooltip = <Tooltip id={path}>{title}</Tooltip>;

  const showHeader = screen.width <= 750;

  return (
    <OverlayTrigger placement="right" overlay={tooltip} animation>
      <li
        className={classes}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Link
          onClick={() => {
            if (reset) reset();
          }}
          to={path}
        >
          {svg ? (
            <img
              src={isHovered && hoverSvg ? hoverSvg : svg}
              style={{ maxWidth: "35px", fill: "white" }}
              alt={title}
            />
          ) : (
            <i className={`fa fa-fw fa-lg ${icon}`} />
          )}
          {showHeader && <span style={{ marginLeft: 5 }}>{title}</span>}
        </Link>
      </li>
    </OverlayTrigger>
  );
}

function NavLink(props) {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <Route
      path={props.path}
      children={({ match }) =>
        navLink(
          match,
          props.path,
          props.icon,
          props.title,
          props.reset,
          props.svg,
          props.hoverSvg,
          isHovered,
          setIsHovered
        )}
    />
  );
}

const ConnectedNavLink = connect(undefined, (dispatch, ownProps) => ({
  reset: () => {
    if (ownProps.listId) {
      const reset = composables({ listId: ownProps.listId }).reset;
      return dispatch(reset());
    }
    return null;
  }
}))(NavLink);

export default withRouter(ConnectedNavLink);

NavLink.propTypes = {
  path: PropTypes.string.isRequired,
  reset: PropTypes.func,
  icon: PropTypes.string,
  svg: PropTypes.string,
  title: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/NavLink/NavLink.jsx